import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { AddBTActivationComponent } from "./add-btactivation/add-btactivation.component";
import { EditBTActivationComponent } from "./edit-btactivation/edit-btactivation.component";
import { EmailBTActivationComponent } from "./email-btactivation/email-btactivation.component";
import { BTActivationPrintRequest } from "./shared/BTActivationPrintRequest";
import { DataService_BusTrackerActivation } from "./shared/data.service";

@Component({
	selector: "app-bus-tracker-activation",
	templateUrl: "./bus-tracker-activation.component.html",
	styleUrls: ["./bus-tracker-activation.component.css"],
})
export class BusTrackerActivationComponent implements OnInit {
	constructor(
		private sanitizer: DomSanitizer,
		private userService: UserService,
		private BTActivationService: DataService_BusTrackerActivation,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadBTActivation();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBTActivation: any;
	lstBTActivation: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ActivationCodeShort", header: "Description" },
		{ field: "AvailableCount", header: "Activations Left" },
		{ field: "TotalCount", header: "Total Issued" },
		{ field: "IssueDateDesc", header: "Issue Date" },
		{ field: "ExpireDateDesc", header: "Expire Date" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadBTActivation() {
		this.loading = true;

		var result = this.BTActivationService.BTActivationSelectList();
		result.subscribe(
			(response) => {
				this.lstBTActivation = response;

				for (var z = 0; z < this.lstBTActivation.length; z++) {
					var next = this.lstBTActivation[z];

					next.PhotoData = this.sanitizer.bypassSecurityTrustResourceUrl(next.QRCode);
				}

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstBTActivation.map((item: any) => item.ActiveDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBTActivation();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddBTActivationComponent, {
			header: "Add Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBTActivation();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedBTActivation == undefined) {
			this.errorMessage = "Select an activation code to edit";
			return;
		}

		var ref = this.dialogService.open(EditBTActivationComponent, {
			header: "Edit Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				ActivationID: this.SelectedBTActivation.ActivationID,
				ActivationCode: this.SelectedBTActivation.ActivationCode,
				ActivationCodeShort: this.SelectedBTActivation.ActivationCodeShort,
				AvailableCount: this.SelectedBTActivation.AvailableCount,
				TotalCount: this.SelectedBTActivation.TotalCount,
				// IssueDate: this.SelectedBTActivation.IssueDate,
				IssueDateDesc: this.SelectedBTActivation.IssueDateDesc,
				ExpireDate: this.SelectedBTActivation.ExpireDate,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBTActivation();
			}
		});
	}

	onPrint() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBTActivation == undefined) {
			this.errorMessage = "Select an activation code to print";
			return;
		}

		//Call SP
		this.Processing = true;

		//Create Request
		let parms: BTActivationPrintRequest = {
			QRTextRaw: this.SelectedBTActivation.QRTextRaw,
		};

		var result = this.BTActivationService.BTActivationPrint(parms);
		result.subscribe(
			(response) => {
				var a = document.createElement("a"); //Create <a>
				a.href = response[0];
				a.download = "QRCode_" + this.SelectedBTActivation.ActivationCode;
				a.click(); //Downloaded file

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onEmail() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBTActivation == undefined) {
			this.errorMessage = "Select an activation code to email";
			return;
		}

		if (this.SelectedBTActivation.Active == 0) {
			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message:
					"Activation code is inactive and can't be used to register users unless the expiration date changes or more licenses are purchased. Are you sure you want to email it?",
				header: "Activation Code Inactive",
				icon: "fa",
				accept: () => {
					this.FinishOpenEmailDialog();
				},
				reject: () => {
					return;
				},
			});
		} else {
			this.FinishOpenEmailDialog();
		}
	}

	FinishOpenEmailDialog() {
		//Call SP
		var ref = this.dialogService.open(EmailBTActivationComponent, {
			header: "Email Activation Code",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				QRCode: this.SelectedBTActivation.QRCode,
				// QRTextRaw: this.SelectedBTActivation.QRTextRaw,
				ExpireDateDesc: String(this.SelectedBTActivation.ExpireDateDesc),
				ActivationCode: this.SelectedBTActivation.ActivationCode,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedBTActivation = val.data;
	}
	onRowUnselect(val) {
		this.SelectedBTActivation = null;
	}
	onRowDblClick(BTActivation) {
		this.SelectedBTActivation = BTActivation;
		this.onEmail();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
